if (!customElements.get('addon-item')) {
    customElements.define('addon-item',
    class AddOn extends HTMLElement {
        constructor() {
            super();
            this.url = this.dataset.url;
            this.select = this.querySelector('select');
            this.price = this.querySelector('.js-price');
            this.addToBundle = this.querySelector('.js-add');
            this.select && this.addEventListener('change', this.changeHandle.bind(this));
        }
        async changeHandle(e) {
            let res = await fetch(`${this.url}?variant=${e.target.value}&section_id=add-on-item`);
            let responseText = await res.text();
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updatePrice(html);
            this.updateAddToBundle(html);
        }
        updatePrice(html) {
            this.price.innerHTML = html.querySelector('.js-price').innerHTML;
        }
        updateAddToBundle(html) {
            let newDisabled = html.querySelector('.js-add').disabled;
            this.addToBundle.disabled = newDisabled;
            if (newDisabled) this.addToBundle.checked = false;
            let newId = html.querySelector('.js-add').value;
            this.addToBundle.value = newId;
        }
    }
);
}
